import React, { useEffect, useRef } from "react";
import InvoiceDetails from "src/pages/BMCPageContainer/Invoices/InvoiceDetails";
import FooterActions from "./AssignBuildingFooter";
import AssignBuildingTitle from "./AssignBuildingTitle";
import {
  getInvoiceStatusOptions,
  setPaymentInitiator,
} from "src/redux/slices/lookupSlice";
import { PaymentInitiator } from "src/resources/enum";
import { useDispatch, useSelector } from "react-redux";
import InvoiceFooter from "src/pages/BMCPageContainer/Invoices/InvoiceFooter";
import { generateInvoiceURLHandler } from "src/utils/common";
import { useLocation } from "react-router";
import { getInvoiceDetails } from "src/redux/slices/invoiceSlice";

const Invoice = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const contentRef = useRef(null);
  const { invoiceID } = useSelector(
    (state: any) => state.invoices?.invoiceDetailsPopupData?.invoiceDetails
  );
  useEffect(() => {
    dispatch(setPaymentInitiator(PaymentInitiator.AssignedBuilding));
  }, []);

  const payInvoiceHandler = (): void => {
    generateInvoiceURLHandler(dispatch, invoiceID);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlInvoiceId = searchParams.get("invoiceId");
    if (urlInvoiceId && !invoiceID) {
      dispatch(getInvoiceDetails(urlInvoiceId) as any);
    }
  }, [location.search, invoiceID, dispatch]);
  useEffect(() => {
    dispatch(getInvoiceStatusOptions() as any);
  }, [dispatch]);
  return (
    <>
      <AssignBuildingTitle title="invoice" />
      <div className="building-details-form">
        <InvoiceDetails contentRef={contentRef} />
        <InvoiceFooter
          showPayButton={true}
          contentRef={contentRef}
          payInvoiceHandler={payInvoiceHandler}
        />
      </div>
    </>
  );
};

export default Invoice;
